import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ApplicationConfigurationLoaderService } from './application-configuration-loader.service';

/**
 * Ensures application configuration (granted policies) is loaded before protected routes.
 * CPNotes: Prevents navigation with empty/stale permission state
 */
export const authorizationReadyGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const loader = inject(ApplicationConfigurationLoaderService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }

  if (loader.ready()) {
    return true;
  }

  return loader.load().pipe(
    map(() => true),
    catchError(() => {
      authService.clearUser();
      loader.clear();
      return of(router.createUrlTree(['/login']));
    })
  );
};
